import React from 'react';
import rightArrowIcon from '../../assets/images/righArrowIcon.svg';
import { handlePageChange } from '../../utils/readiumUtils';
import { useDispatch } from 'react-redux';
import { EvaluateElement } from '../../types/EvaluateElement';
import { setEvaluateOpen } from '../../features/Evaluate/EvaluateOpenSlice';
import { setEvaluateMediaHandler } from '../../features/EvaluatePdfPlayer/EvaluatePdfPlayerSlice';

interface EvaluateChapterItemProps {
    chapter: EvaluateElement;
}

const EvaluateChapterItem: React.FC<EvaluateChapterItemProps> = ({
    chapter,
}) => {
    const dispatch = useDispatch();
    const handleClick = () => {
        dispatch(
            setEvaluateMediaHandler({
                url: chapter.url,
                isOpen: true,
                resource_id: chapter.resource_id.toString(),
                resource_type: chapter.resourceType,
                resource_title: chapter.title,
            })
        );
        handlePageChange(window);
    };

    return (
        <div className="chapter-item px-6 py-3 hover:bg-[#F7F9FD]">
            <button
                data-testid="evaluate-chapter-item-button"
                onClick={handleClick}
                className="w-full h-12 bg-transparent rounded text-black flex flex-row justify-between text-md items-center"
            >
                <div className="flex flex-row items-center flex-1 min-w-0">
                    <span className="text-lg truncate">{chapter.title}</span>
                </div>
                <div className="flex flex-row items-center">
                    <span className="pl-20 pr-4">
                        <img src={rightArrowIcon} alt="right arrow icon" />
                    </span>
                </div>
            </button>
        </div>
    );
};

export default EvaluateChapterItem;
